// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"6064b0bd","260":"f1da8b08","385":"7551ea62","927":"65353b05"}[chunkId] + ".chunk.js";
};